<template>
  <div>
    <v-list-item :to="to" two-line link exact>
      <v-list-item-title>{{ name }}</v-list-item-title>
    </v-list-item>
    <v-divider></v-divider>
  </div>
</template>

<script>
  export default {
    props: ['to', 'name'],
  }
</script>